import React from "react";
import { Link } from "react-router-dom";
import sections from "./data/index";

const popularPages = [
  { label: "Quick Start", section: "getting-started", slug: "quick-start" },
  { label: "Admissions", section: "modules", slug: "admissions" },
  { label: "Fee Collection", section: "modules", slug: "fee-management" },
  { label: "Admin Guide", section: "guides", slug: "admin-guide" },
  { label: "Roles & Permissions", section: "getting-started", slug: "roles-and-permissions" },
];

export default function DocsIndex() {
  const sectionEntries = Object.entries(sections);

  return (
    <div className="max-w-[720px] mx-auto px-6 py-12">
      {/* Hero */}
      <div className="mb-12">
        <h1
          className="font-['Syne'] font-bold text-[#0F1B3D] mb-3"
          style={{ fontSize: "clamp(24px, 4vw, 36px)", lineHeight: 1.2 }}
        >
          Acadence Documentation
        </h1>
        <p
          className="font-['DM_Sans'] text-[#475569]"
          style={{ fontSize: 17, lineHeight: 1.7, maxWidth: 520 }}
        >
          Everything you need to get the most out of Acadence — from first login to
          advanced administration across all 21 modules.
        </p>
      </div>

      {/* Section cards grid */}
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 mb-12">
        {sectionEntries.map(([key, section]) => {
          const Icon = section.icon;
          const firstPage = section.pages[0];
          const pageCount = section.pages.length;
          return (
            <Link
              key={key}
              to={firstPage ? `/docs/${key}/${firstPage.slug}` : `/docs`}
              className="group rounded-xl p-5 border transition-all hover:shadow-md"
              style={{
                borderColor: "#E2E8F0",
                background: "#FFFFFF",
              }}
            >
              <div className="flex items-start gap-3 mb-3">
                <div
                  className="flex items-center justify-center rounded-lg shrink-0"
                  style={{
                    width: 36,
                    height: 36,
                    background: "rgba(75,123,245,0.1)",
                  }}
                >
                  <Icon size={18} style={{ color: "#4B7BF5" }} />
                </div>
                <div>
                  <h2
                    className="font-['Syne'] font-bold text-[#0F1B3D] group-hover:text-[#4B7BF5] transition-colors"
                    style={{ fontSize: 16 }}
                  >
                    {section.label}
                  </h2>
                  <span
                    className="font-['DM_Sans'] text-[#94A3B8]"
                    style={{ fontSize: 12 }}
                  >
                    {pageCount} {pageCount === 1 ? "page" : "pages"}
                  </span>
                </div>
              </div>
              <p
                className="font-['DM_Sans'] text-[#64748B]"
                style={{ fontSize: 13, lineHeight: 1.65 }}
              >
                {section.description}
              </p>
            </Link>
          );
        })}
      </div>

      {/* Popular pages */}
      <div>
        <h2
          className="font-['Syne'] font-bold text-[#0F1B3D] mb-4"
          style={{ fontSize: 18 }}
        >
          Popular Pages
        </h2>
        <div className="flex flex-wrap gap-2">
          {popularPages.map((p) => (
            <Link
              key={`${p.section}-${p.slug}`}
              to={`/docs/${p.section}/${p.slug}`}
              className="inline-flex items-center rounded-full px-4 py-1.5 font-['DM_Sans'] transition-all hover:bg-[#4B7BF5] hover:text-white border"
              style={{
                fontSize: 13,
                color: "#4B7BF5",
                borderColor: "rgba(75,123,245,0.3)",
                background: "rgba(75,123,245,0.05)",
              }}
            >
              {p.label}
            </Link>
          ))}
        </div>
      </div>
    </div>
  );
}
